import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import Button from '@/modules/common/components/Button';
import PropTypes from 'prop-types';

const ButtonMenu = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const getButtonProps = () => ({color: 'primary', variant: 'contained', ...props.buttonProps});

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // noinspection JSValidateTypes
    return (
        <>
            <Button onClick={handleClick} {...getButtonProps()}>
                {props.buttonContent}
            </Button>
            <Menu anchorEl={anchorEl}
                  open={Boolean(anchorEl)} onClose={handleClose}
                  keepMounted={true}
                  style={{marginLeft: '-5px'}}
                  {...props.menuProps}
            >
                {props.children}
            </Menu>
        </>
    );
};

ButtonMenu.propTypes = {
    buttonProps: PropTypes.object,
    buttonContent: PropTypes.node.isRequired,
    menuProps: PropTypes.object,
};

export default ButtonMenu;
